import * as React from 'react'

class Empty extends React.Component<any, any>{
  render(){
    return (
      <>
      {/* 
      <img style={{display: 'block', margin: '0 auto', maxWidth: '100%', height: 'auto'}} src={`${config.IMG_BASE_PATH}/arkea_computer.png`} />
      */}
      </>
    )
  }
}

export default Empty;



// WEBPACK FOOTER //
// ./src/page/Empty/Empty.tsx